import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/variables.css';

const Footer: React.FC = () => {
  return (
    <footer style={{ 
      backgroundColor: '#fff', 
      padding: '60px 20px', 
      marginTop: '80px', 
      borderTop: '1px solid rgba(0,0,0,0.05)'
    }}>
      <div style={{ 
        maxWidth: 'var(--max-width)', 
        margin: '0 auto', 
        display: 'grid', 
        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', 
        gap: '40px' 
      }}>
        <div>
          <h3 style={{ color: 'var(--primary-color)', marginBottom: '20px' }}>The F.I.N.D.ca</h3>
          <p style={{ color: 'var(--text-secondary)', lineHeight: '1.6' }}>
            The professional network for finding local junior sitters. Connecting parents with certified youth in their community.
          </p>
        </div>
        
        <div>
          <h4 style={{ marginBottom: '20px' }}>Quick Links</h4>
          <ul style={{ listStyle: 'none', padding: 0, lineHeight: '2' }}>
            <li><Link to="/">Discover Sitters</Link></li>
            <li><Link to="/categories">Browse Categories</Link></li>
            <li><Link to="/shopping">Sitter Shopping</Link></li>
            <li><Link to="/contact">Contact Support</Link></li>
          </ul>
        </div>
        
        <div>
          <h4 style={{ marginBottom: '20px' }}>For Sitters</h4>
          <ul style={{ listStyle: 'none', padding: 0, lineHeight: '2' }}>
            <li><Link to="/login">Sitter Login</Link></li>
            <li><Link to="/signup">Join as Sitter</Link></li>
            <li><Link to="/dashboard">My Dashboard</Link></li>
          </ul>
        </div>
        
        <div>
          <h4 style={{ marginBottom: '20px' }}>Contact</h4>
          <p style={{ margin: '5px 0' }}>Nova Scotia, Canada</p>
        </div>
      </div>
      
      <div style={{ 
        textAlign: 'center', 
        marginTop: '60px', 
        paddingTop: '20px', 
        borderTop: '1px solid rgba(0,0,0,0.05)',
        color: 'var(--text-secondary)',
        fontSize: '0.9rem'
      }}>
        © 2026 The F.I.N.D.ca. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
